// @ts-nocheck
import { HeaderIsFixedParameter } from "@store/Framework/Store/Bunzl/Components/Header/HeaderTypes";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type Parameter = HeaderIsFixedParameter;
type HandlerType = Handler<Parameter>;

export const dispatchIsFixed: HandlerType = props => {
    props.dispatch({
        type: "Store/Components/Header/SetIsFixed",
        parameter: props.parameter,
    });
};

export const chain = [dispatchIsFixed];

const setFixedHeader = createHandlerChainRunner(chain, "SetFixedHeader");
export default setFixedHeader;
